import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLocale } from '../contexts/LocaleContext';
import { useNotification } from '../contexts/NotificationContext';
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import { FormControl } from 'baseui/form-control';
import { HeadingLarge, ParagraphMedium } from 'baseui/typography';
import {
  PageContainer,
  SectionContainer,
  FlexColumnCentered
} from '../styles/controllerPageStyles';
import {
  ErrorMessage,
  AuthButtonContainer
} from '../styles/authPageStyles';
import PageFooter from '../components/common/PageFooter';

const UpdatePasswordPage = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { updateUser, setPasswordRecoveryMode } = useAuth(); // Need to expose this from AuthContext
  const { t } = useLocale();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      return setError(t('errors.auth.passwordMismatch'));
    }

    try {
      setError('');
      setLoading(true);
      const { error } = await updateUser({ password: password });
      if (error) throw error;

      showNotification(t('pages.updatePassword.success'), 'success');
      if (setPasswordRecoveryMode) {
        setPasswordRecoveryMode(false);
      }
      navigate('/dashboard');
    } catch (err) {
      setError(t('errors.auth.updateFailed') || 'Failed to update password');
      showNotification(err.message, 'error');
    }
    setLoading(false);
  };

  return (
    <PageContainer>
      <FlexColumnCentered>
        <HeadingLarge>{t('pages.updatePassword.title')}</HeadingLarge>
      </FlexColumnCentered>
      <SectionContainer>
        <ParagraphMedium style={{ marginBottom: '24px' }}>
          {t('pages.updatePassword.description')}
        </ParagraphMedium>
        <form onSubmit={handleSubmit}>
          <FormControl label={() => t('common.passwordLabel')}>
            <Input
              id="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </FormControl>
          <FormControl label={() => t('common.confirmPasswordLabel')}>
            <Input
              id="password-confirm-input"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </FormControl>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <AuthButtonContainer>
            <Button type="submit" isLoading={loading}>
              {t('pages.updatePassword.button')}
            </Button>
          </AuthButtonContainer>
        </form>
      </SectionContainer>
      <PageFooter />
    </PageContainer>
  );
};

export default UpdatePasswordPage;
